<template>
  <div class="bnkj-content">
    <img src="../../../assets/image/kjqg/bnkjhz/qycxzf-banner.png" class="bnkj-banner">
    <div class="category-nav">
      <div class="bnkj-category">
        <div class="category-item" v-for="item,ind in categoryList" :key="ind" :class="{active:item.title == activeTitle }" @click="setActiveTit(item)">{{item.title}}</div>

      </div>
    </div>
    <div class="list-content">
      <div class="bnkj-list">
        <div class="bnkj-item" v-for="item,ind in kjhzList" :key="ind" @click="toDetail(item)">
          <div class="item-img">
            <div :style="`background-image: url(${item.cover})`"></div>
          </div>
          <div class="item-title">
            <div class="title-text">{{item.title}}</div>
          </div>
        </div>
        <div class="bnkj-empty"></div>
        <div class="bnkj-empty"></div>
        <div class="bnkj-empty"></div>
      </div>
      <div v-if="pageNum > 1" class="pagination">
        <a-pagination v-model="page" :total="total" :page-size="pageSize" @change="onPagesChange" size="small" :item-render="itemRender" />
      </div>
      <div v-else-if="kjhzList.length <= 0" class="noData-box">
        <img src="../../../assets/image/jsckzyxy/empty.png" alt="" />
        <div class="text">暂无相关内容</div>
      </div>
    </div>

    <div class="spin-con" v-if="loading">
      <a-spin>
        <a-icon slot="indicator" type="loading" style="font-size: 24px" spin />
      </a-spin>
    </div>
  </div>
</template>

<script>
import services from "../../../assets/js/services.js";
import { mapActions } from "vuex";
import utils from "../../../assets/js/utils.js";
export default {
  data() {
    return {
      school_code: localStorage.getItem("schoolCode"),
      specialId: services.KJQG_SPECIAL_ID,
      kjhzList: [],
      page: 1,
      total: 0,
      pageSize: 16,
      pageNum: 0,
      activeTitle: "太空逐梦",
      loading: false,
      categoryList: [{
        title: "太空逐梦",
      }, {
        title: "海疆探秘",
      },
      {
        title: "数字互联",
      },
      {
        title: "基建通途",
      }, {
        title: "智能制造",
      },
      {
        title: "绿能新生",
      },]
    }
  },
  async created() {
    let res = await this.getAppsLoginUserInfo();
    this.isChrome = utils.bowerUserAgent();
    if (res.code != "0000") {
      this.$message.info("请先登录！");
      this.$router.push({ path: `/${this.school_code}/kjqg/kjqgIndex` });
    }
    if (this.$route.query.ind > -1) {
      this.activeTitle = this.categoryList[this.$route.query.ind].title
    }
    this.getkjhzList()
  },
  methods: {
    ...mapActions(["goAppsDetailsBeforeLogin", "getAppsLoginUserInfo"]),
    async getkjhzList() {
      this.loading = true;
      let res = await services.getAreaSzztkLists({
        page: this.page,
        length: this.pageSize,
        count: 0,
        school_code: this.school_code,
        special_id: this.specialId,
        kind: "1",
        column_name: this.activeTitle,
        order_by: "asc"
      });
      if (res.code == "0000" && res.data.items.length > 0) {
        this.kjhzList = res.data.items
        this.pageNum = res.data.page_num;
        this.total = res.data.total;
      } else {
        this.kjhzList = [];
        this.pageNum = 0;
        this.total = 0;
      }
      this.loading = false;

    },
    setActiveTit(item) {
      this.activeTitle = item.title
      this.page = 1;
      this.getkjhzList();

    },
    onPagesChange(val) {
      this.page = val;
      this.getkjhzList();
    },
    itemRender(current, type, originalElement) {
      if (type === "prev") {
        return <a>上一页</a>;
      } else if (type === "next") {
        return <a>下一页</a>;
      }
      return originalElement;
    },
    toDetail(item) {
      if (item) {
        this.goAppsDetailsBeforeLogin().then(() => {
          if (item.is_open_url == 2) {
            window.open(`${item.source_url}`, "_blank");
          } else {
            this.$router.push({
              path: `/${this.school_code}/kjqg/detail`,
              query: {
                id: item.id,
                column_id: item.column_id,
                columnPath: "qycxzf",
              },
            });
          }

        });
      }
    },
  }
}
</script>

<style lang="less" scoped>
body {
  // overflow-x: hidden;
}
.bnkj-content {
  padding: calc(3.64vw + 42px) 0 50px;
  background-image: url("../../../assets/image/kjqg/common/common-bg.jpg");
  background-size: 100% auto;
  .bnkj-banner {
    width: 100%;
    margin-bottom: 20px;
  }
  .category-nav {
    width: 100%;
    overflow: hidden;
    .bnkj-category {
      margin: 0 auto;
      width: 1200px;
      display: flex;
      justify-content: center;
      position: relative;
      &::before {
        content: "";
        display: block;
        width: 360px;
        height: 12px;
        background-image: url("../../../assets/image/kjqg/bnkjhz/category-icon-l.png");
        background-size: cover;
        background-position: center;
        position: absolute;
        top: 50%;
        left: 0;
        transform: translate(-100%, -50%);
      }
      &::after {
        content: "";
        display: block;
        width: 378px;
        height: 12px;
        background-image: url("../../../assets/image/kjqg/bnkjhz/category-icon-r.png");
        background-size: cover;
        background-position: center;
        position: absolute;
        top: 50%;
        right: 0;
        transform: translate(100%, -50%);
      }
      .category-item {
        width: 171px;
        height: 57px;
        background-image: url("../../../assets/image/kjqg/bnkjhz/category-item.png");
        background-size: cover;
        background-position: center;
        font-weight: bold;
        font-size: 17px;
        color: #3a4046;
        display: flex;
        align-items: center;
        text-align: center;
        justify-content: center;
        margin-left: 11px;
        cursor: pointer;
        &:hover {
          background-image: url("../../../assets/image/kjqg/bnkjhz/category-item-hover.png");
          color: #ffffff;
        }
        &.active {
          background-image: url("../../../assets/image/kjqg/bnkjhz/category-item-hover.png");
          color: #ffffff;
        }
        &:first-child {
          margin-left: 0;
        }
      }
    }
  }
  .list-content {
    .bnkj-list {
      width: 1200px;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      .bnkj-item {
        width: 272px;
        margin-top: 32px;
        cursor: pointer;
        &:hover {
          .item-img {
            div {
              transform: scale(1.1);
              transition: all 0.3s;
            }
          }
          .item-title {
            .title-text {
              z-index: 11;
              width: 100%;
              position: absolute;
              overflow: unset;
              white-space: wrap !important;
              color: #1e63cb;
              width: 100%;
            }
          }
        }
        .item-img {
          width: 100%;
          height: 153px;
          border-radius: 4px 4px 0px 0px;
          overflow: hidden;
          background: #1e63cb;

          div {
            width: 100%;
            height: 100%;
            background-size: cover;
            background-position: center;
          }
        }
        .item-title {
          height: 48px;

          position: relative;
          .title-text {
            font-weight: bold;
            padding: 10px 13px 13px;
            font-size: 16px;
            color: #333333;
            line-height: 26px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            background: #ffffff;
            border-radius: 0px 0px 4px 4px;
          }
        }
      }

      .bnkj-empty {
        width: 272px;
      }
    }
    .pagination {
      display: flex;
      justify-content: center;
      align-items: center;
      position: relative;
      margin-top: 45px;
      z-index: 2;
      ::v-deep.ant-pagination {
        .ant-pagination-prev,
        .ant-pagination-next {
          margin: 0 15px;
          a {
            color: #1869e4;
          }
        }
        .ant-pagination-item {
          margin: 0 5px;
          border-radius: 0;
          a {
            color: #1869e4;
          }
          &.ant-pagination-item-active {
            background-color: #1869e4;
            border: 1px solid transparent;
            a {
              color: #fff;
            }
          }
        }
      }
    }
  }

  .spin-con {
    position: fixed;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.3);
    top: 0;
    z-index: 999;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
</style>